import React from 'react';
import {
  Formik,
  Form,
} from 'formik';
import mapValues from 'lodash/mapValues';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import {
  initFormValues,
} from '~/commons/helpers';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import LangTabs from '../layout/LangTabs.jsx';

import env from '~/commons/config/env';

const defaults = {
  address: mapValues(env.langs, () => ''),
  csHotline: mapValues(env.langs, () => ''),
  whatsapp: mapValues(env.langs, () => ''),
  leaveMsg: mapValues(env.langs, () => ''),
  busHrs: mapValues(env.langs, () => ''),
  complHotline: mapValues(env.langs, () => ''),
};

const FormConfig = ({
  contact,
}) => {
  const [res, req] = useHttpStatus();

  return (
    <Formik
      initialValues={initFormValues(defaults, contact)}
      onSubmit={async (values, actions) => {
        const { status } = await req({
          method: 'patch',
          url: `/api/site/contacts/${contact._id}`,
          data: values,
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values });
        }
      }}
    >
      <Form>
        <FormHttpSaveBtn
          res={res}
          className="btn-primary mb-3"
          disabled={false}
        />
        <FormHttpAlert res={res} />

        <LangTabs>
          {({ lang }) => (
            <div className="pt-3">
              <FormGroup
                name={`address.${lang}`}
                label="Address"
              />
              <FormGroup
                name={`csHotline.${lang}`}
                label="Customer Service Hotline"
              />
              <FormGroup
                name={`whatsapp.${lang}`}
                label="Whatsapp"
              />
              <FormGroup
                name={`leaveMsg.${lang}`}
                label="Leave Us a Message"
              />
              <FormGroup
                name={`busHrs.${lang}`}
                label="Business Hours"
              />
              <FormGroup
                name={`complHotline.${lang}`}
                label="Complaint Hotline"
              />
            </div>
          )}
        </LangTabs>

      </Form>
    </Formik>
  );
};

export default FormConfig;
